import { Component, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleNotch, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-waiting-modal',
  templateUrl: './waiting-modal.component.html',
  styleUrls: ['./waiting-modal.component.scss'],
  imports: [FontAwesomeModule, TranslateModule]
})
export class WaitingModalComponent implements OnInit {
  faSpinner = faSpinner;
  faCircleNotch = faCircleNotch;
  loading: boolean = true;
  modal;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

}
